import { USE_MOCK } from '@/lib/api/env';
import type { PresenceApi } from './presenceAdapter';
import { presenceHttp } from './presenceHttp';
import { presenceMock } from './presenceMock';

/**
 * LIVE by default — `/api/v1/presence` plus `presence:<userId>` topics on the
 * gateway. `VITE_USE_MOCK=true` restores the simulated roster; every consumer
 * is typed against `PresenceApi` only, so neither knows the difference.
 */
export const presenceApi: PresenceApi = USE_MOCK ? presenceMock : presenceHttp;
